<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control displayName="Name" description="Provide a name." [control]="formGroup.controls.name" />
    <unity-dropdown-control
      displayName="Type"
      description="Choose the vendor type."
      [values]="$vendorTypes()"
      [control]="formGroup.controls.type_id" />
    <unity-textbox-control
      displayName="TIN"
      description="Enter the vendor's Taxpayer Identification Number (TIN)."
      [control]="formGroup.controls.tin" />
    <unity-file-uploader-control
      displayName="W9"
      description="Provide the vendor's W9 form (in PDF format)"
      [control]="formGroup.controls.w9_upload_id"
      [allowedExtensions]="['pdf']" />

    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="returnToDashboardAction" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
